export enum EmberRoute {
  AccountsImport = 'accounts_import',
  AnnualReports = 'annual_reports',
  Bank = 'bank_sync',
  BankAccounts = 'bank_accounts',
  BankAccount = 'bank_account',
  BankConnections = 'bank_integrations',
  BankImport = 'bank_import',
  BankImportColumns = 'bank_import_columns',
  BankPayment = 'bank_payment',
  BankReact = 'bank_sync_react',
  ChartOfAccounts = 'chart_of_accounts_settings',
  Contact = 'contact',
  ContactBalancePayment = 'contact_balance_payment',
  ContactsCustomer = 'contact.customer',
  ContactsNew = 'contacts.new',
  ContactsSupplier = 'contact.supplier',
  Daybook = 'daybook',
  Daybooks = 'daybooks',
  DaybookTransaction = 'daybook_transaction',
  Financing = 'financing',
  Inbox = 'inbox',
  InboxVouchers = 'inbox.voucher_inbox',
  Integrations = 'integrations',
  Invoice = 'invoice',
  InvoiceCreditNote = 'invoice.credit',
  InvoiceLateFee = 'invoice_late_fee',
  Invoices = 'invoices.index',
  InvoicesNew = 'invoices.new',
  InvoicesNewCreditNote = 'invoices.new_credit_note',
  InvoiceTemplate = 'template',
  Login = 'login',
  Logout = 'logout',
  Organization = 'organization',
  Product = 'product',
  Products = 'products',
  ProductsNew = 'products.new',
  Quote = 'quote',
  Quotes = 'quotes.index',
  QuotesNew = 'quotes.new',
  RecurringInvoice = 'recurring_invoice',
  RecurringInvoices = 'recurring_invoices',
  RecurringInvoicesNew = 'recurring_invoices.new',
  Root = '/',
  SalesTaxReturnSettings = 'sales_tax_return_settings',
  SalaryIntegration = 'salary',
  SettingsAccessTokens = 'access_tokens',
  SettingsAccounting = 'accounting_settings',
  SettingsCardPayments = 'card_payments_settings',
  SettingsNotification = 'notification_settings',
  SettingsNotificationUmbrella = 'umbrella_notification_settings',
  SettingsOrganization = 'organization_info',
  SettingsOrganizationFeatures = 'organization_features_settings',
  SettingsOrganizationInvoicing = 'invoicing_settings',
  SettingsOrganizationEInvoicing = 'e_invoicing_settings',
  SettingsOrganizationUsers = 'organization_users',
  SettingsOrganizations = 'organizations',
  SettingsPrivacy = 'privacy',
  SettingsPrivacyUmbrella = 'umbrella_privacy',
  SettingsSubscription = 'organization_subscription',
  SettingsSubscriptions = 'organization_subscription.index',
  SettingsSubscriptionsPlansSelection = 'organization_subscription.plans_selection',
  SettingsUser = 'user_info',
  SettingsUserUmbrella = 'umbrella_user_info',
  SettingsVatRates = 'vat_rates_settings',
  SignupGuide = 'signup-guide',
  Transaction = 'transaction',
  Umbrella = 'umbrella',
  UmbrellaOrganizations = 'umbrella_organizations',
  UmbrellaProfile = 'umbrella_profile',
  UmbrellaRoles = 'umbrella_roles',
  UmbrellaInvoices = 'umbrella_invoices',
  UmbrellaSubscriptions = 'umbrella_subscriptions',
  UmbrellaUsers = 'umbrella_users',
  Vouchers = 'vouchers',
}
